// Author Lin
// Date 2021-10-16 10:31:47

import * as model from "@/model/mintalMes/inventory/MintalMesInventoryQuantityAdjustmentModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesInventoryQuantityAdjustment(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_INVENTORY_URL,
    })
    .buildStore()
